module.exports = __webpack_public_path__ + "nrent_icon.svg";